import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { IncomingInvoiceDeliveryNoteList } from "@msuite/utils/types";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useIncomingInvoiceDeliveryNotes() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Query */
	const query = useQuery({
		queryKey: ["incoming-invoices", "delivery-notes"],
		enabled: citadel?.can("read", "IncomingInvoice") === true,
		queryFn: async () => {
			const response = await client.incoming_invoices["delivery-notes"].$get();
			const data = await responseHandler(response);
			return data.deliveryNotes as IncomingInvoiceDeliveryNoteList;
		},
	});

	/** Return */
	return { ...query, deliveryNotes: query.data ?? [] };
}
